/**
 * Class overrides that put the app-standard colours on the shared <Button>.
 *
 * <Button>'s primary/ghost variants paint with the org's branding variable
 * (var(--primary)), and the component concatenates classes without merging,
 * so a plain `bg-v2accent` can lose to the variant's own background depending
 * on stylesheet order. The `!` modifier makes these win regardless.
 */

/** Primary action: teal accent fill, white text. Use with the default variant. */
export const ACCENT_BUTTON =
  '!bg-v2accent hover:!bg-v2accent/90 !text-white focus:!ring-v2accent !shadow-none';

/** Quiet icon button: ink-500, ink on hover, no brand colour. Use with variant="ghost". */
export const INK_GHOST_BUTTON =
  '!text-ink-500 hover:!text-ink hover:!bg-paper-2 focus:!ring-v2border';

/** Destructive icon button that is only red on hover/focus. Use with variant="ghost". */
export const DANGER_GHOST_BUTTON =
  '!text-ink-500 hover:!text-red-600 hover:!bg-red-50 dark:hover:!bg-red-950/30 focus:!ring-red-500';
